export const IMPORTING_ACCOUNT_MAP = 'IMPORTING_ACCOUNT_MAP';
export const IMPORTING_ACCOUNT_MAP_SUCCESS = 'IMPORTING_ACCOUNT_MAP_SUCCESS';
export const IMPORTING_ACCOUNT_MAP_FAILURE = 'IMPORTING_ACCOUNT_MAP_FAILURE';

export const FETCH_ACCOUNTS_FOR_ACCOUNT_MAP = 'FETCH_ACCOUNTS_FOR_ACCOUNT_MAP';
export const FETCH_ACCOUNTS_FOR_ACCOUNT_MAP_SUCCESS = 'FETCH_ACCOUNTS_FOR_ACCOUNT_MAP_SUCCESS';
export const FETCH_ACCOUNTS_FOR_ACCOUNT_MAP_FAILURE = 'FETCH_ACCOUNTS_FOR_ACCOUNT_MAP_FAILURE';

export const FETCHING_DATA_FOR_ACCOUNTS_MAP_MODAL = 'FETCHING_DATA_FOR_ACCOUNTS_MAP_MODAL';
export const FETCHING_DATA_FOR_ACCOUNTS_MAP_MODAL_FINISHED = 'FETCHING_DATA_FOR_ACCOUNTS_MAP_MODAL_FINISHED';
